import {state as lifecycle} from 'fragments/lifecycle';

export default {
	...lifecycle,
	initialized: false,
	organizations: [],
	teams: [],
	buildings: [],
};
